function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M160 384h32c18 0 32-14 32-32s-14-32-32-32h-32c-18 0-32 14-32 32s14 32 32 32zm0-96h32c18 0 32-14 32-32s-14-32-32-32h-32c-18 0-32 14-32 32s14 32 32 32zm0-96h192c18 0 32-14 32-32s-14-32-32-32H160c-18 0-32 14-32 32s14 32 32 32zm256 64H288c-18 0-32 14-32 32v160H96V64h320zm-96 136v-72h60zM480 48c0-26-22-48-48-48H80C54 0 32 22 32 48v416c0 26 22 48 48 48h208c10 0 18-5 24-12l1 1 160-192-1-1c5-5 8-12 8-20z"
})));